import { ImResponse, doorClient, storeHomeClient, resolve } from '.';

export type disputeReason = 'NON_RECEIPT' | 'OTHER' | 'NOT_RECEIVED';
export enum DisputeOperate {
  争议 = 'DISPUTE',
  向shopee争议 = 'DISPUTE_TO_SHOPEE',
  预争议 = 'PRE_DISPUTE',
  修改预争议 = 'UPDATE_PRE_DISPUTE',
}
export interface CommonRefund {
  /** 平台的店铺Id 必填 */
  externalStoreId: string;
  /** 平台订单id 必填 */
  externalTradeId: string;
  /** 退款单号 */
  returnSn: string;
}

/** 拒绝退货: 向虾皮争议 */
export type DisputeReturnRequest =
  | (CommonRefund & {
      platform: 'SHOPEE';
      /** 争议原因 enum: https://leyan.yuque.com/czpqnb/yzt2rg/dpbk1k#uX7wq */
      disputeReason: disputeReason;
      /** 争议描述 256字符限制 */
      disputeTextReason: string;
      /** 电邮 */
      email: string;
      /** 举证图片url 最多3张 */
      image: string[];
      operate?: DisputeOperate;
      disputeReasonId?: string;
    })
  | {
      platform: 'MERCADO' | 'KWAI';
      returnSn: string;
      operate: 'DISPUTE';
    };
/** 拒绝退货: 向虾皮争议 */
export interface DisputeReturnResponse {
  code: number;
  msg: string;
}
export const disputeReturn = (param: DisputeReturnRequest) => {
  return doorClient.post<
    ImResponse<{
      userId: number;
      orgId: number;
    }>
  >('/trade/v1/return/dispute', param);
};

export type LazadaOperate = 'CONFIRM_RETURN_REFUND' | 'CONFIRM';

export type KwaiOperate = 'CONFIRM_RETURN_REFUND' | 'CONFIRM_ONLY_REFUND' | 'FULL_REFUND';

export type IConfirmReturnOperate =
  /** 接受仅退款申请 不传默认该字段, 兼容老版本 */
  | 'CONFIRM'
  /** 全额退款 */
  | 'FULL_REFUND'
  | 'RETURN_REFUND'
  | 'CONFIRM_ONLY_REFUND'
  | 'CONFIRM_CHANGE';

/** 同意退款
POST /trade/v1/return/confirm
接口ID：16537473
接口地址：https://www.apifox.cn/web/project/625489/apis/api-16537473 */
export interface ConfirmReturnRequest extends CommonRefund {
  operate?:
    | IConfirmReturnOperate
    | LazadaOperate
    | Conversation.Trade.MercadoReturnOperationType
    | KwaiOperate;
  externalType?: Omit<General.PlatformUpperCase, 'TOKOPEDIA' | 'ALIEXPRESS'>;
  returnOrderItemId?: string[];
}
export const confirmReturn = (param: ConfirmReturnRequest) => {
  return doorClient.post<
    ImResponse<{
      userId: number;
      orgId: number;
    }>
  >('/trade/v1/return/confirm', param);
};

export interface RefuseBody {
  externalStoreId: string;
  returnSn: string;
  externalType?: General.PlatformUpperCase;
  externalOrderId?: string;
  returnOrderItemId: string[];
  reasonId: string;
  comment: string;
  image: string[];
  operate: 'REFUSE' | 'REFUSE_CHANGE';
}

export const refuse = (body: RefuseBody) => {
  return doorClient.post('/trade/v1/return/refuse', body);
};

export interface RefuseReasonParams {
  externalStoreId: string;
  externalTradeId?: string;
  returnSn: string;
  returnOrderItemId?: string[];
  externalType?: General.PlatformUpperCase;
}

export interface RefuseReasonResponse {
  failReturnOrderItemId: string[];
  availableReasonList: {
    reasonId: string;
    // eslint-disable-next-line camelcase
    muti_language_text: string;
    text: string;
  }[];
  email: string;
}

export const refuseReason = (params: RefuseReasonParams) => {
  return resolve(
    doorClient.get<ImResponse<RefuseReasonResponse>>('/trade/v1/return/reason', {
      params: {
        ...params,
        returnOrderItemId: params.returnOrderItemId?.join(','),
      },
    }),
  );
};

export type ITradeOfferV1Req =
  | {
      platform: 'SHOPEE';
      returnExternalId: string;
      returnType: Conversation.Trade.IReturnType;
      refundAmount: number;
    }
  | {
      platform: 'MERCADO';
      returnExternalId: string;
      operate: 'OFFER';
      percentage: string;
    }
  | {
      platform: 'TIKTOK' | 'TIKTOK_US';
      returnExternalId: string;
      refundAmount: number;
    };
/** 提出部分退款; 再次提案
POST /oversea-door/trade/v1/offer
接口ID：16534241
接口地址：https://www.apifox.cn/web/project/625489/apis/api-16534241 */
export const tradeOfferV1 = (body: ITradeOfferV1Req) => {
  return resolve(doorClient.post<ImResponse<any>>('/trade/v1/offer', body));
};

/** 接受提案 done
POST /oversea-door/trade/v1/acceptOffer
接口ID：16535648
接口地址：https://www.apifox.cn/web/project/625489/apis/api-16535648 */
export const tradeAcceptOfferV1 = (body: {
  returnExternalId: string;
  operate: 'ACCEPT_OFFER' | 'CONFIRM_RETURN_REFUND' | 'WAIT_RETURN';
}) => {
  return resolve(doorClient.post<ImResponse<any>>('/trade/v1/acceptOffer', body));
};

export const openReturn = () => {
  return resolve(
    storeHomeClient.get<
      ImResponse<{
        open: boolean;
      }>
    >('/admin/shopee/openReturn', {}),
  );
};

export interface OfficialHistoryResponseData {
  historyList: {
    time: string;
    operator: string;
    picture: string[];
  }[];
}

/**
 * for lazada till
 */
export const officialHistoryV1 = (
  returnSn: string,
  returnOrderItemId: string,
  externalType?: string,
) => {
  return resolve(
    doorClient.get<ImResponse<OfficialHistoryResponseData>>('/trade/v1/return/officialHistory', {
      params: {
        returnSn,
        returnOrderItemId,
        externalType: 'LAZADA',
      },
    }),
  );
};

interface ReturnReviewRejectBody {
  platform: General.PlatformUpperCaseTunnel;
  returnSn: string;
  reasonId: string;
  comment: string;
  image?: string[];
}

// 验货不通过
export const returnReviewReject = (body: ReturnReviewRejectBody) => {
  return resolve(doorClient.post<ImResponse<undefined>>('/trade/v1/returnReview/fail', body));
};

// 验货通过
export const returnReviewResolve = (
  platform: General.PlatformUpperCaseTunnel,
  returnSn: string,
) => {
  return resolve(
    doorClient.post<ImResponse<undefined>>('/trade/v1/returnReview/ok', { platform, returnSn }),
  );
};

/**
 * 撤销预争议
 * 先接入shopee
 */
export const cancelPreDispute = (data: {
  returnSn: string;
  externalStoreId: string;
  externalTradeId: string;
}) => {
  return doorClient.delete('/trade/v1/return/dispute', {
    data: {
      operate: 'UNDO_PRE_DISPUTE',
      platform: 'SHOPEE',
      ...data,
    },
  });
};
